import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "content"]

  connect() {
    // Handle initial visibility based on screen size
    this.updateVisibility()
    
    // Listen for window resize events
    window.addEventListener('resize', () => this.updateVisibility())
  }

  disconnect() {
    // Clean up event listener
    window.removeEventListener('resize', () => this.updateVisibility())
  }

  toggle() {
    // Only toggle on mobile
    if (window.innerWidth < 1280) { // 1280px is xl breakpoint
      this.sidebarTarget.classList.toggle('hidden')
      this.overlayTarget.classList.toggle('hidden')
    }
  }

  close() {
    // Only close on mobile
    if (window.innerWidth < 1280) {
      this.sidebarTarget.classList.add('hidden')
      this.overlayTarget.classList.add('hidden') 
    }
  }

  updateVisibility() {
    if (window.innerWidth >= 1280) {
      // On desktop, always show sidebar and hide overlay
      this.sidebarTarget.classList.remove('hidden')
      this.overlayTarget.classList.add('hidden')
    } else {
      // On mobile, hide both by default
      this.sidebarTarget.classList.add('hidden')
      this.overlayTarget.classList.add('hidden')
    }
  }
} 